var _style, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagramView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.DiagramView-st0 {\r\n\t\t\tfill: currentColor;\r\n\t\t}\r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "DiagramView-st0",
    d: "M5.9,0H1.2C0.5,0,0,0.5,0,1.2v4.7c0,0.7,0.5,1.2,1.2,1.2h4.7c0.7,0,1.2-0.5,1.2-1.2V1.2C7.1,0.5,6.6,0,5.9,0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "DiagramView-st0",
    d: "M14.8,0h-4.7C9.4,0,8.9,0.5,8.9,1.2v4.7c0,0.7,0.5,1.2,1.2,1.2h4.7c0.7,0,1.2-0.5,1.2-1.2V1.2 C16,0.5,15.5,0,14.8,0z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "DiagramView-st0",
    d: "M5.9,8.9H1.2C0.5,8.9,0,9.4,0,10.1v4.7C0,15.5,0.5,16,1.2,16h4.7c0.7,0,1.2-0.5,1.2-1.2v-4.7 C7.1,9.4,6.6,8.9,5.9,8.9z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "DiagramView-st0",
    d: "M14.8,8.9h-4.7c-0.7,0-1.2,0.5-1.2,1.2v4.7c0,0.7,0.5,1.2,1.2,1.2h4.7c0.7,0,1.2-0.5,1.2-1.2v-4.7 C16,9.4,15.5,8.9,14.8,8.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramView);
export default __webpack_public_path__ + "static/media/DiagramView.9715475ba42f00f2dd2ebe34cc253973.svg";
export { ForwardRef as ReactComponent };